<template lang="pug">
    router-link(v-if="isRelative" :to="to" )
        slot
    a(v-else :href="to" v-bind="$props")
        slot
</template>

<script>
    export default {
        name: "DynamicLink",
        props: {
            to: String,
        },
        computed: {
            isRelative() {
                return this.to && !/^https?:\/\//i.test(this.to);
            }
        }
    };
</script>
